import { useContext } from "react";
import { LocaleContext } from "./LocaleContext";
import { _throw, IllegalStateError } from "shared-ts-utils-core";

export const useLocale = (): Intl.Locale => {
  return (
    useContext(LocaleContext) ??
    _throw(
      new IllegalStateError("useLocale must be used within a LocaleProvider")
    )
  );
};
